import React from "react";
import { RoutePermittedRole } from "shared/constants/AppConst";

export const SuccessStoriesConfig = [
  {
    permittedRole: RoutePermittedRole.User,
    path: "/success-stories",
    component: React.lazy(() => import("./success-stories")),
  },
];
